'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tabs = function tabs() {
    var MORE_BTN_TEXT = 'More';
    var selectors = {
        moreBtn: '.js-tabs__tab_more',
        popover: '.js-popover_customised',
        selectedTab: '.js-tabs__tab_selected',
        tabLabel: '.js-tabs__label'
    };
    var classes = {
        highlightedTab: 'ui-tabs__tab_selected',
        moreBtnActive: 'ui-tabs__tab_more_major'
    };

    var $moreBtn = (0, _jquery2.default)(selectors.moreBtn);

    function applyMoreBtn() {
        var $popover = (0, _jquery2.default)(selectors.popover);
        var $moreBtnLbl = $moreBtn.find(selectors.tabLabel);
        var $selectedTab = (0, _jquery2.default)(selectors.selectedTab);
        var selectedTabName = $selectedTab.text().trim();

        function onMoreBtnClick(e) {
            e.stopPropagation();
            $popover.toggle();
            $moreBtn.toggleClass(classes.moreBtnActive);
        }

        function onDocumentClick(e) {
            if (!_jquery2.default.contains($popover[0], e.target)) {
                $popover.hide();
                $moreBtn.removeClass(classes.moreBtnActive);
            }
        }

        function onWindowResize() {
            if ($selectedTab.css('display') !== 'none') {
                $moreBtnLbl.text(MORE_BTN_TEXT);
                $moreBtn.removeClass(classes.highlightedTab);
            } else {
                $moreBtnLbl.text(selectedTabName);
                $moreBtn.addClass(classes.highlightedTab);
            }
        }

        $moreBtn.on('click', onMoreBtnClick);
        (0, _jquery2.default)(window.document).on('click', onDocumentClick);
        (0, _jquery2.default)(window).on('resize', onWindowResize);

        onWindowResize();
    }
    if (!!$moreBtn.length) {
        applyMoreBtn();
    }
};
exports.default = tabs;


//////////////////
// WEBPACK FOOTER
// ./~/rp-gui-guide/lib/js/tabs.js
// module id = 2669
// module chunks = 1